module.exports = __webpack_public_path__ + "img/png_logo.efaea67f.png";